import { z } from 'zod';
import { BlockSchema } from '@/components/canvas/blocks/schema';
import { ElementSchema } from '@/components/canvas/document/schema/elements';

export const GridGuideSettingsSchema = z.object({
  columns: z.number().int().min(0).max(16).default(4),
  rows: z.number().int().min(0).max(16).default(0),
  gutter: z.number().int().min(0).max(120).default(12),
  margin: z.number().int().min(0).max(120).default(12),
});

export const PageGuideSettingsSchema = z.object({
  enabled: z.boolean().default(false),
  system: z.enum(['grid']).default('grid'),
  grid: GridGuideSettingsSchema.default({
    columns: 4,
    rows: 0,
    gutter: 12,
    margin: 12,
  }),
});

export const PageSchema = z.object({
  id: z.string(),
  name: z.string().default(''),
  size: z.object({ width: z.number().default(1920), height: z.number().default(1080) }),
  background: z
    .object({
      type: z.enum(['color', 'gradient', 'image', 'transparent']).default('color'),
      value: z.string().optional(),
      imagePositionX: z.number().optional(),
      imagePositionY: z.number().optional(),
      backgroundColor: z.string().optional(),
    })
    .default({ type: 'color' }),
  elements: z.array(ElementSchema).default([]),
  blocks: z.array(BlockSchema).default([]),
  guideSettings: PageGuideSettingsSchema.default({
    enabled: false,
    system: 'grid',
    grid: { columns: 4, rows: 0, gutter: 12, margin: 12 },
  }),
  workspaceLayout: z
    .object({
      x: z.number(),
      y: z.number(),
      zIndex: z.number().optional(),
      rotation: z.number().optional(),
    })
    .optional(),
  viewState: z
    .object({
      zoom: z.number(),
      panX: z.number(),
      panY: z.number(),
      showGuides: z.boolean().optional(),
    })
    .optional(),
  thumbnail: z.string().optional(),
  createdAt: z.number().default(() => Date.now()),
  updatedAt: z.number().default(() => Date.now()),
});
